import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "appyhour_admin_token";
const ADMIN_KEY = "appyhour_admin";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function getAdmin() {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_KEY));
  } catch {
    return null;
  }
}
export function setAdminSession(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
}
export function clearAdminSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/admin/login`, { email, password });
  setAdminSession(data.token, data.admin);
  return data.admin;
}

export async function adminGoogleLogin(sessionId) {
  const { data } = await axios.post(`${API}/auth/admin/google`, { session_id: sessionId });
  setAdminSession(data.token, data.admin);
  return data.admin;
}

export async function playerGoogleLogin(sessionId) {
  const { data } = await axios.post(`${API}/auth/player/google`, { session_id: sessionId });
  return data; // { handle, name, banned, picture, email }
}

export async function fetchVenues() {
  const { data } = await axios.get(`${API}/venues`);
  return data;
}
export async function fetchVenue(id) {
  const { data } = await axios.get(`${API}/venues/${id}`);
  return data;
}
export async function createVenue(payload) {
  const { data } = await axios.post(`${API}/venues`, payload, { headers: authHeaders() });
  return data;
}
export async function updateVenue(id, payload) {
  const { data } = await axios.put(`${API}/venues/${id}`, payload, { headers: authHeaders() });
  return data;
}
export async function deleteVenue(id) {
  const { data } = await axios.delete(`${API}/venues/${id}`, { headers: authHeaders() });
  return data;
}
export async function generateProfile(name, type, location) {
  const { data } = await axios.post(
    `${API}/venues/generate-profile`,
    { name, type, location },
    { headers: authHeaders() }
  );
  return data.blurb;
}

export async function uploadVenuePhoto(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/venues/upload-photo`, form, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return data.photo_url; // relative "/api/files/..."
}

export function fileUrl(photoUrl) {
  if (!photoUrl) return "";
  return photoUrl.startsWith("http") ? photoUrl : `${process.env.REACT_APP_BACKEND_URL}${photoUrl}`;
}
export async function generateQuiz(category, difficulty) {
  const { data } = await axios.post(`${API}/generate-quiz`, { category, difficulty }, { timeout: 45000 });
  return data.questions;
}

export async function registerMember(handle, name) {
  const { data } = await axios.post(`${API}/members/register`, { handle, name });
  return data; // { banned, handle, name }
}
export async function fetchMembers() {
  const { data } = await axios.get(`${API}/members`, { headers: authHeaders() });
  return data;
}
export async function banMember(id) {
  const { data } = await axios.post(`${API}/members/${id}/ban`, {}, { headers: authHeaders() });
  return data;
}
export async function unbanMember(id) {
  const { data } = await axios.post(`${API}/members/${id}/unban`, {}, { headers: authHeaders() });
  return data;
}

export const PRIZE_KINDS = [
  { id: "points", label: "Bonus Points", emoji: "⭐" },
  { id: "free_coffee", label: "Free Coffee", emoji: "☕" },
  { id: "food_drink", label: "Food / Drink Offer", emoji: "🍔" },
  { id: "custom", label: "Custom Offer", emoji: "🎁" },
];

export function prizeEmoji(kind) {
  return (PRIZE_KINDS.find((k) => k.id === kind) || {}).emoji || "🎁";
}
